import { cn } from '@/helpers/common';

export const MAIN_CONTENT_ID = 'main-content';

export default function SkipLink({ className }: { className?: string }) {
  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      className={cn(
        'sr-only focus-visible:not-sr-only focus-visible:fixed focus-visible:top-4 focus-visible:left-4 focus-visible:z-1000',
        'focus-visible:px-4 focus-visible:py-2 focus-visible:rounded-sm focus-visible:bg-white focus-visible:text-black focus-visible:font-bold focus-visible:shadow-lg',
        className,
      )}
    >
      Skip to main content
    </a>
  );
}
